import Ajax from '../lib/ajax.js'

// const prefix = 'kfimentry.zhuanzhuan.com/api/kfim/transfer/';
// const prefix = 'kfimentry.zhuanzhuan.com/info/kfim/through/'
const zzPrefix = 'app.zhuanzhuan.com/zz/transfer/'
const zzApollo = 'https://feconf.zhuanzhuan.com/feconf/'
const afterSalePrefix = 'zzkfass.zhuanzhuan.com/kf-user/through/'
const zzOpen = 'app.zhuanzhuan.com/zzopen/spamlogic/'
const API = {
  GET_QUESTIONNAIRE_CONFIG: `${zzPrefix}getQuestionnaireConfigApp`,
  GET_EVALUATE_INFO: `${zzPrefix}getEvaluateInfoApp`,
  EVALUATE_BY_STAR: `${zzPrefix}evaluateByStarApp`,
  GET_NICK_NAME_AND_PHOTO: `${zzPrefix}getNickNameAndPhoto`,
  GET_TICKETS_FOR_USER: `${zzPrefix}getTicketsForUser`,
  GET_TICKET_DETAIL_FOR_USER: `${zzPrefix}getTicketDetailForUser`,
  GET_PERIODS_FOR_APPOINT_MENT: `${afterSalePrefix}getPeriodsForAppointment`,
  OPERATION_APP_INFO: `${afterSalePrefix}operationAppInfo`,
  GET_QUESTIONNAIRE_FORM_INFO: `${afterSalePrefix}getQuestionnaireFormInfo`,
  SUBMIT_QUESTION_NAIRE: `${afterSalePrefix}submitQuestionnaire`,
  USER_URGET_TICKET: `${zzPrefix}userUrgetTicket`,
  USER_LEAVING_MESSAGE: `${zzPrefix}userLeavingMessage`,
  GET_TICKET_LOGS_FOR_USER: `${zzPrefix}getTicketLogsForUser`,
  GET_USER_REPORT_DETAIL: `${zzPrefix}getUserReportDetail`,
  GET_DEPOSIT_INFO: `${zzPrefix}getdepositinfo`,
  GET_DEPOSIT_AUDITINFO: `${zzPrefix}getdepositauditinfo`,
  GET_DEPOSIT_NOTIFY: `${zzPrefix}getdepositnotify`,
  DEPOSIT_SUBMIT: `${zzPrefix}depositsubmit`,
  GET_BIZ_CERTIFICATOIN_STATUS: `${zzPrefix}getbizcertificationstatus`,
  GET_USER_AUTHCARD_INFO: `${zzPrefix}getuserauthcardinfo`,
  ID_CARD_PICALL_CHECK: `${zzPrefix}idcardpicallcheck`,
  NEED_FACE_AUTH: `${zzPrefix}needfaceauth`,
  GET_CERTIFICATION_STATUS: `${zzPrefix}getcertificationstatus`,
  GET_CLOUD_CHECK_CONFIG: `${zzPrefix}getcloudcheckconfig`,
  GET_CLOUD_CHECK_PRODUCT: `${zzPrefix}getcloudcheckproduct`,
  GET_MSG_BY_TYPE: `${zzPrefix}getmsgbytype`,
  SUBMIT_CLOUD_CHECK: `${zzPrefix}submitcloudcheck`,
  GET_CITY_INFO: `${zzPrefix}getCityInfo`,
  HAS_ARBITRATION_ORDERS: `${zzPrefix}hasArbitrationOrders`,
  GET_AUTHENTICATION_RESULT: `${zzPrefix}getauthenticationresult`,
  GET_ALREADY_CERTIFICATION_INFO: `${zzPrefix}getalreadycertificationinfo`, // 获取姓名身份证号
  GET_PAGE_TEXT: `${zzPrefix}getpagetext`,
  GET_MAIMAI_RESULT: `${zzPrefix}getmaimairesult`,
  KF_IM_EVALUATE: `${zzPrefix}evaluateApp`,
  GET_INFO_FORCERTIFI_CHECK: `${zzPrefix}getinfoforcertificheck`,
  GET_SDK_CALLBACK_TEXT: `${zzPrefix}getsdkcallbacktext`,
  INSERT_CERTIFI_CHECK: `${zzPrefix}insertcertificheck`,
  FK_ADD_REPORT: `${zzPrefix}addreport`,
  FK_ADD_REPORT_NEW: `${zzPrefix}addreportnew`,
  GET_ANTI_SPAM_RESULT: `${zzPrefix}getantispamresult`,
  GET_INFO_LIST: `${zzPrefix}getinfolist`,
  GET_ONLINE_MSG: 'https://hi.zhuanzhuan.com/zzmsg_get_asc_cloud_msg',
  USER_LOGIN: 'https://gr.zhuanzhuan.com/user_login',
  USER_LOGOUT: 'https://gr.zhuanzhuan.com/user_logout',
  GET_ORDER_LIST: `${zzPrefix}getorderlist`,
  GET_REPORT_HISTORY_DETAIL: `${zzPrefix}getreporthistorydetail`,
  REVOKE_REPORT: `${zzPrefix}submitbackreport`,
  GET_CHOOSE_ITEM: `${zzPrefix}disputeoption`,
  GET_REPORT_HISTORYS: `${zzPrefix}getreporthistorys`,
  GET_REPORT_REASONS: `${zzPrefix}getreportreasons`,
  GET_REPORT_NOTICEANDSHOW: `${zzPrefix}getnoticeandshow`,
  GET_REPORT_UNREADCOUNT: `${zzPrefix}getredcount`,
  GET_REPORT_HASREAD: `${zzPrefix}doreadreport`,
  GET_REPORT_ADDADVISE: `${zzPrefix}addappraise`,
  FK_GET_USER_PIC: `${zzPrefix}getuserpic`,
  HAS_TRADING_ORDER: `${zzPrefix}hastradingorder`,
  GET_SEC_CENTER: `${zzPrefix}securitycenter`,
  GET_PLAT_RULE: `${zzPrefix}platrule`,
  GET_SEC_KNOW: `${zzPrefix}securityknowledge`,
  GET_SEC_CHECK: `${zzPrefix}securitycheck`,
  GET_SEC_CHECK_HISTORY: `${zzPrefix}securitycheckhistory`,
  DELETE_PRODUCT: `${zzPrefix}delInfo`,
  CANCEL_LIMIT: `${zzPrefix}cancellimit`,
  GET_PAY_CHECK_HISTORY: `${zzPrefix}compensatehistory`,
  GET_PAY_CHECK_DETIAL: `${zzPrefix}compensatesearch`,
  GET_PAY_CHECK_STATUS: `${zzPrefix}compensateappraisecheck`,
  GET_PAY_CHECK_APPLY_LIST: `${zzPrefix}compensateappraisegetorderapplylist`,
  GET_PAY_CHECK_REPORT_LIST: `${zzPrefix}compensateappraisegetorderneedreport`,
  SUBMIT_PAY_CHECK: `${zzPrefix}compensateappraisesubmit`,
  GET_REPCEIVE_CHECK: `${zzPrefix}compensatereceivecheck`,
  GET_PAY_CHECK_REPCEIVE: `${zzPrefix}compensatereceivesucc`,
  ADD_USER_ADVICE: `${zzPrefix}adduseradvice`,
  GET_USER_ADVICE_CONF: `${zzPrefix}getuseradviceconf`,
  ZLJ_MODIFY_ADDRESS: `${afterSalePrefix}zljModifyAddress`,
  ZLJ_USER_LOGIN: `${zzPrefix}zljUserLogin`,
  KEFU_CHAT_VALID: `${zzPrefix}kefuChatValid`,
  // 语音验证
  LOADINGCALL: `${zzPrefix}outboundcall`,
  //资质提交页面
  SUBMIT_BIZ_LICENSE: `${zzPrefix}checkbizlicense`,
  SUBMIT_BIZ_PERMIT: `${zzPrefix}submitbizpermit`,
  GET_BIZ_LICENSE: `${zzPrefix}getbizlicense`,
  GET_BIZ_TYPELIST: `${zzPrefix}getbizpermittype`,
  //找靓机-实人认证
  GET_ZLJ_REAUTH_TEXT: `${zzPrefix}getsdkuserauthtext`,
  // 绑定第三方信息
  BIND_THIRD_PARTY: `${zzPrefix}bindThirdParty`,
  // 获取订单列表
  GET_MY_ORDERS: `${zzPrefix}getMyOrders`,
  // 商品发布资质页面
  CHECK_AUDIT_STATUS: `${zzPrefix}qualcheckstatus`,
  SUBMIT_AUDIT_INFO: `${zzPrefix}qualsubmit`,
  GET_SUBMIT_CONFIG: `${zzPrefix}qualgetconfig`,
  //新资质提交流程
  CHECK_AUDIT_STATUS_NEW: `${zzPrefix}qualcheckstatusnew`,
  SUBMIT_AUDIT_INFO_NEW: `${zzPrefix}qualsubmitnew`,
  // 营业执照OCR
  LICENSE_INFO_OCR: `${zzPrefix}getlicenseocrinfobyurl`,
  // 获取营业执照认证信息
  GET_BIZ_LICENSE_INFO: `${zzPrefix}getbizlicenseinfo`,
  // 获取营业执照认证状态
  GET_BIZ_LICENSE_STATUS: `${zzPrefix}getbizlicensestatus`,
  // 获取营业执照认证结果页信息
  GET_BIZ_LICENSE_RESULT: `${zzPrefix}getbizlicenseresult`,
  //查询问题列表--投诉中心
  GET_QUESTION_LIST: `${zzPrefix}getQuestionList`,
  // 提交投诉信息--投诉中心
  ADD_USER_COMPLAIN: `${zzPrefix}addUserComplain`,
  // 获取投诉状态信息--投诉中心
  CHECK_USER_COMPLAIN_STATUS: `${zzPrefix}checkUserComplainStatus`,
  // 获取当前登录用户的昵称
  GET_USER_INFO: `${zzPrefix}getUserInfo`,
  // 获取客服中心数据
  GET_CUSTOZMER_CENTER_RESULT: `${zzPrefix}getCustomerCenterResult`,
  // 获取客服中心自助服务配置接口
  GET_KF_SELFSERVICE_ENTRANCE: `${zzPrefix}getKfSelfServiceEntrance`,
  // 获取新客服中心需要过滤的业务线id
  KF_CENTER_BUSINESS_FILTER: `${zzApollo}system`,
  //实人认证更改姓名
  GET_RENAME_INFO: `${zzPrefix}getrenameinfo`,
  SUBMIT_RENAME_INFO: `${zzPrefix}submitrenameinfo`,
  //新实人认证
  NEW_REALAUTH_OCR: `${zzPrefix}certificaterecognition`,
  NEW_REALAUTH_SUBMIT_AUTO: `${zzPrefix}certificatesubmit`,
  NEW_REALAUTH_SUBMIT_HANDLE: `${zzPrefix}certificatesubmitcheck`,
  //个人隐私信息
  PRIVATE_INFO: `${zzPrefix}getselfauthenticateinfo`,
  PRIVATE_INFO_CARDSUPPLY: `${zzPrefix}certificatecomplementsubmit`,
  //新举报
  NEW_REPORT_GET_REASON: `${zzPrefix}getreporttypenewlogic`,
  NEW_REPORT_GET_QUESTION: `${zzPrefix}getreportquestionnewlogic`,
  NEW_REPORT_GET_EXAMPLE: `${zzPrefix}getreportvoucherexample`,
  NEW_REPORT_GET_HISTORY: `${zzPrefix}getreporthistorynewlogic`,
  NEW_REPORT_GET_HAS_READ: `${zzPrefix}doreadreportnewlogic`,
  NEW_REPORT_GET_DETAIL: `${zzPrefix}getreporthistorydetailnewlogic`,
  NEW_REPORT_SUBMIT: `${zzPrefix}addreportnewlogic`,
  NEW_REPORT_SUPPLY_SUBMIT: `${zzPrefix}addreportsupplementnewlogic`,
  NEW_REPORT_GET_RED_COUNT: `${zzPrefix}getreportredcount`,
  NEW_REPORT_EVALUATE: `${zzPrefix}addappraisenewlogic`,
  GET_PERSONAL_STATEMENT: `${zzPrefix}getpersonalstatement`,
  SUBMIT_PERSONAL_STATEMENT: `${zzPrefix}submitpersonalstatement`,
  SUBMIT_BUSINESS_PLACE: `${zzPrefix}submitbusinessplace`,
  UPDATE_BIZ_LICENSEINFO: `${zzPrefix}updatebizlicenseinfo`,
  GET_BUSINESS_INFO_BY_TYPE: `${zzPrefix}getbusinessinfobytype`,
  //实名验证
  GET_LAST_CERTIFICATION_INFO: `${zzPrefix}getlastcertificationinfo`,
  SUBMIT_ATICATION_CHECK: `${zzPrefix}submitauthenticationcheck`,
  QUERY_DISCLOSURE_STATUS: `${zzPrefix}querydisclosurestatus`,
  QUERY_DISCLOSURE_ORDER_INFO: `${zzPrefix}querydisclosureorderinfo`,
  DO_CHECK_BEFORE_DISCLOSUR: `${zzPrefix}docheckbeforedisclosure`,
  SUBMIT_DISCLOSUR_EMAIL: `${zzPrefix}submitdisclosureemail`,
  CHECK_DISCLOSUR_EMAIL: `${zzPrefix}checkdisclosureemail`,
  QUERY_DISCLOSURE_EMAIL: `${zzPrefix}querydisclosureemail`,
  SUBMIT_DISCLOSUR: `${zzPrefix}submitdisclosure`,
  //监督举报
  CASE_TRACK_REPORT_CONFIG: `${zzPrefix}getcasetrackreportconfig`,
  CASE_TRACK_REPORT_SUBMIT: `${zzPrefix}submitcasetrackreport`,
  GET_CASE_TRACK_STATUS_BY_ORDER_ID: `${zzPrefix}getcasetrackstatusbyorderid`,
  SUPPLEMENT_CASE_TRACK_REPORT: `${zzPrefix}supplementcasetrackreport`,
  // 安全中心-按钮跳转校验接口
  SAFE_CENTER_BUTTON_CHECK: `${zzOpen}safecenterbuttoncheck`,
  // 港澳台扫脸之前的提交证件照片接口
  PRESUBMIT_BEFORE_FACE_CER: `${zzOpen}presubmitbeforefacecer`,
  // 获取实人和港澳台状态接口
  GET_CER_RECOGNITION_AND_FACE_STATUS: `${zzOpen}getcerrecognitionandfacestatus`
}

// Jsonp请求
const Jsonp = (url, param, opts = {}) =>
  Ajax(
    url,
    param,
    Object.assign(
      {
        method: 'jsonp'
      },
      opts
    )
  )
// axios请求
const Json = (url, param, method = 'get', opts) =>
  Ajax(
    url,
    param,
    Object.assign(
      {
        method
      },
      opts
    )
  )

/**
 * @description 新评价 问卷获取
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.skillId -必填项，技能组id
 * @return {Promise}
 **/
export const getQuestionnaireConfig = (data) => Jsonp(API.GET_QUESTIONNAIRE_CONFIG, data)

/**
 * @description 获取离线评价相关信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.skillId -必填项，会话id
 * @return {Promise}
 **/
export const getEvaluateInfo = (data) => Jsonp(API.GET_EVALUATE_INFO, data)

/**
 * @description 离线评价提交（星星)
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.convId -必填项，会话id
 * @param {String} params.score -必填项，评价分值
 * @param {String} params.content -必填项，评价内容
 * @param {String} params.optionIds -必填项，选中标签值
 * @param {String} params.questionnaireId -必填项，问卷配置id
 * @return {Promise}
 **/
export const evaluateByStar = (data) => Jsonp(API.EVALUATE_BY_STAR, data)

/**
 * @description 获取用户信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.userids -必填项，用户id,以“，”分割
 * @return {Promise}
 **/
export const getNickNameAndPhoto = (data) => Json(API.GET_NICK_NAME_AND_PHOTO, data)

/**
 * @description 查询用户可见工单列表
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.uid -必填项，需要手动传用户uid
 * @return {Promise}
 **/
export const getTicketsForUser = (data) => Json(API.GET_TICKETS_FOR_USER, data)

/**
 * @description 查询工单关联信息详情
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.uid -必填项，需要手动传用户uid
 * @param {String} params.ticketId -必填项，工单id
 * @return {Promise}
 **/
export const getTicketDetailForUser = (data) => Json(API.GET_TICKET_DETAIL_FOR_USER, data)

/**
 * @description 获取可预约时段信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.ticketId -必填项，工单id
 * @return {Promise}
 **/
export const getPeriodsForAppointment = (data) => Json(API.GET_PERIODS_FOR_APPOINT_MENT, data)

/**
 * @description 添加、更新预约信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.kid -必填项，用户id
 * @param {String} params.type -必填项，操作类型 0 预约 1修改预约时间 2手动完成预约3自动完成
 * @param {String} params.startTime -必填项，预约开始时间
 * @param {String} params.endTime -必填项，预约结束时间
 * @param {String} params.ticketId -必填项，工单id
 * @return {Promise}
 **/
export const operationAppInfo = (data) => Json(API.OPERATION_APP_INFO, data)

/**
 * @description M-获取评价表单信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.recordId -必填项，记录id
 * @return {Promise}
 **/
export const getQuestionnaireFormInfo = (data) => Json(API.GET_QUESTIONNAIRE_FORM_INFO, data)

/**
 * @description 用户催单
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.ticketId -必填项，工单id
 * @return {Promise}
 **/
export const userUrgetTicket = (data) => Json(API.USER_URGET_TICKET, data)

/**
 * @description 用户工单留言
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.ticketId -必填项，工单id
 * @param {String} params.remark -必填项，留言信息
 * @param {String} params.operatorUid -选填项，操作人uid
 * @param {String} params.operatorName -操作人昵称
 * @return {Promise}
 **/
export const userLeavingMessage = (data) =>
  Json(API.USER_LEAVING_MESSAGE, data, 'post', {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
  })

/**
 * @description 提交售后评价
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.recordId -必填项，记录id
 * @param {String} params.score -必填项，得分
 * @param {String} params.content -评价内容
 * @param {String} params.optionIds -选中标签值optionId（,隔开）
 * @return {Promise}
 **/
export const submitQuestionnaire = (data) => Json(API.SUBMIT_QUESTION_NAIRE, data)

// --------------------需要回归的接口---------------------

/**
 * @description 用户侧查询工单流水
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.ticketId -必填项，工单id
 * @return {Promise}
 **/
export const getTicketLogsForUser = (data) => Json(API.GET_TICKET_LOGS_FOR_USER, data)

/**
 * @description 获取用户被举报详细情况
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.toUid -必填项，对方的uid
 * @return {Promise}
 **/
export const getUserReportDetail = (params) => Json(API.GET_USER_REPORT_DETAIL, params)

/**
 * @description 获取保证金相关信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.depositId -必填项，保证金id
 * @param {String} params.infoId -必填项，商品id
 * @param {String} params.orderId -订单id-非必传
 * @return {Promise}
 **/
export const getdepositinfo = (params) => Json(API.GET_DEPOSIT_INFO, params)

/**
 * @description 获取保证金审核后的信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.auditId -必填项，审核id
 * @return {Promise}
 **/
export const getdepositauditinfo = (params) => Json(API.GET_DEPOSIT_AUDITINFO, params)

/**
 * @description 获取保证金-通知页
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.type -必填项，区分不同场景
 * @param {String} params.depositId -必填项，保证金id
 * @param {String} params.infoId -必填项，商品id
 * @param {String} params.orderId -订单id-非必传
 * @return {Promise}
 **/
export const getdepositnotify = (params) => Json(API.GET_DEPOSIT_NOTIFY, params)

/**
 * @description 用户提交保证金申诉申请
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.depositId -必填项，保证金id
 * @param {String} params.orderId -必填项，订单id
 * @param {String} params.picList -必填项，图片列表-12张
 * @param {String} params.infoId -必填项，商品id
 * @param {String} params.appealReason -必填项，申诉理由-200字
 * @return {Promise}
 **/
export const depositsubmit = (params) => Json(API.DEPOSIT_SUBMIT, params, 'post')

/**
 * @description 商家实人状态获取
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.sourceCode -必填项，业务来源
 * @return {Promise}
 **/
export const getbizcertificationstatus = (params) => Json(API.GET_BIZ_CERTIFICATOIN_STATUS, params)

/**
 * @description 根据订单号获取用户实名信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.authtype -必填项，认证类型，二次挑战value=challenge
 * @param {String} params.agreementno
 * @return {Promise}
 **/
export const getuserauthcardinfo = (params) => Json(API.GET_USER_AUTHCARD_INFO, params)

/**
 * @description 校验身份证照片与姓名身份证号是否匹配
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.sourceCode -必填项，业务来源
 * @param {String} params.idCard -必填项，身份证号
 * @param {String} params.name -必填项，姓名
 * @param {String} params.pic -必填项，身份证图片，人像面在前，国徽面在后，以"|"隔开
 * @return {Promise}
 **/
export const idcardpicallcheck = (params) => Json(API.ID_CARD_PICALL_CHECK, params, 'post')

/**
 * @description 商家是否需要进行扫脸
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.name -必填项
 * @param {String} params.idCard -必填项，身份证号
 * @param {String} params.sourceCode -必填项
 * @return {Promise}
 **/
export const needfaceauth = (params) => Json(API.NEED_FACE_AUTH, params)

/**
 * @description 获取实人认证状态
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const getcertificationstatus = (params) => Json(API.GET_CERTIFICATION_STATUS, params)

/**
 * @description 云验货-获取验货结果文案
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.infoId -必填项
 * @return {Promise}
 **/
export const getcloudcheckconfig = (params) => Json(API.GET_CLOUD_CHECK_CONFIG, params)

/**
 * @description 云验货-获取云验货商品
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.infoId -必填项
 * @return {Promise}
 **/
export const getcloudcheckproduct = (params) => Json(API.GET_CLOUD_CHECK_PRODUCT, params)

/**
 * @description 延迟打款-解冻页面
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.type -必填项，type = 2 是茜羽的延迟打款提示，type=1 是云验货
 * @return {Promise}
 **/
export const getmsgbytype = (params) => Json(API.GET_MSG_BY_TYPE, params)

/**
 * @description 云验货-提交
 * @param {Object} params - 必填项
 * @param {Object} params.checkType - 0:正常验货|1:无法验货-通过其他途径卖出|2:无法验货-其他原因
 * @param {Object} params.infoId
 * @param {Object} params.evidence - 拍摄照片
 * @param {Object} params.express_num - 用快递单号
 * @param {Object} params.reason - 用户填写的详情描述
 * @param {Object} params.id
 * @return {Promise}
 **/
export const submitcloudcheck = (params) => Json(API.SUBMIT_CLOUD_CHECK, params, 'post')

/**
 * @description 延迟打款-解冻页面
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.lng -必填项，经度
 * @param {String} params.lat -必填项，纬度
 * @return {Promise}
 **/
export const getCityInfo = (params) => Json(API.GET_CITY_INFO, params)

/**
 * @description 判断用户是否有仲裁订单
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const hasArbitrationOrders = (params) => Json(API.HAS_ARBITRATION_ORDERS, params)

/**
 * @description 身份认证提交信息并获得验证结果
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.sourcecode -必填项，认证来源页面
 * @param {String} params.name -必填项，真实姓名
 * @param {String} params.idcard -必填项，身份证号
 * @return {Promise}
 **/
export const getauthenticationresult = (params) => Json(API.GET_AUTHENTICATION_RESULT, params, 'post')

/**
 * @description 身份认证获取页面文案信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.sourcecode -必填项，认证来源页面
 * @return {Promise}
 **/
export const getpagetext = (params) => Json(API.GET_PAGE_TEXT, params)

/**
 * @description 脉脉授权后调风控接口，返回认证结果
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.mmUid -必填项，脉脉uid
 * @param {String} params.accessToken -必填项，脉脉授权token
 * @return {Promise}
 **/
export const getmaimairesult = (params) => Json(API.GET_MAIMAI_RESULT, params)

/**
 * @description 用户发送离线评价信息
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.kefuUid -必填项，客服转转id
 * @param {String} params.convId -必填项，会话id
 * @param {String} params.score -必填项，评价分值
 * @param {String} params.skillId -必填项，技能组id
 * @return {Promise}
 **/
export const kfImEvaluate = (params) => Json(API.KF_IM_EVALUATE, params)

/**
 * @description 实人认证人工审核页面拉取最近一条流水的身份证号和姓名
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const getinfoforcertificheck = (params) => Json(API.GET_INFO_FORCERTIFI_CHECK, params)

/**
 * @description 获取结果页文案和按钮
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.code -必填项，腾讯错误码
 * @param {String} params.sourcecode -必填项，来源页面
 * @param {String} params.agreementNo -必填项，订单号
 * @return {Promise}
 **/
export const getsdkcallbacktext = (params) => Json(API.GET_SDK_CALLBACK_TEXT, params)

/**
 * @description 插入实人认证人工审核流水
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.entry -必填项，来源入口online/offline
 * @param {String} params.cardid -必填项，身份证号
 * @param {String} params.name -必填项，名字
 * @param {String} params.picfront -必填项，身份证照片前面
 * @param {String} params.picback -必填项，身份证照片背面
 * @return {Promise}
 **/
export const insertcertificheck = (params) => Json(API.INSERT_CERTIFI_CHECK, params)

/**
 * @description 插入实人认证人工审核流水
 * @param {Object} params - 必填项
 * @param {Object} params.toUid - 被举报用户的uid
 * @param {Object} params.content - 用户举报填写的内容
 * @param {Object} params.pics - 用户举报上传的图片的url
 * @param {Object} params.reasonId - 用户举报的原因分类的id
 * @param {Object} params.chooseType - 用户举报勾选的证据 1：商品 2：私信 3：私信 4：其他
 * @param {Object} params.chooseEvidence - 用户举报勾选的证据内容
 * @param {Object} params.moneyLoss - 用户举报有金额损失时填写的金额损失
 * @param {Object} params.moneyLossPics - 用户举报有金额损失时填写的资损凭证图片
 * @param {Object} params.from - 【透传】举报来源主要有 ：用户举报：2，商品举报：3，私信文本举报：1，私信图片举报：4，私信视频举报：5
 */
export const fkAddReport = (params) => Json(API.FK_ADD_REPORT, params, 'post')

/**
 * @description 提交举报
 * @param {Object} params - 必填项
 * @param {Object} params.beReportUid - 被举报用户的uid
 * @param {Object} params.pics - 用户举报上传的图片的url
 * @param {Object} params.reason - 用户举报时候选择的分类描述
 * @param {Object} params.reasonId - 用户举报的原因分类的id
 * @param {Object} params.reportContent - 用户举报填写的内容
 * @param {Object} params.reportSource - 【透传】举报来源主要有 ：用户举报：2，商品举报：3，私信文本举报：1，私信图片举报：4，私信视频举报：5
 */
export const fkAddReportNew = (params) => Json(API.FK_ADD_REPORT_NEW, params, 'post')

/**
 * @description 获取spam结果
 * @param {Object} params - 必填项
 * @param {Object} params.toUid - bereporteduid-被举报者UID
 * @param {Object} params.infoId - 商品id-没有可以不传
 * @param {Object} params.videoId - 短视频id-没有可以不传
 * @param {Object} params.type - 举报URL中from字段（1-商品页面，2-用户页面，7-短视频页面，4-私信文字页面 ）
 * @param {Object} params.subOp - 举报原因页阻止弹窗subOp=10
 * @param {Object} params.opType - 场景
 */
export const getantispamresult = (params) => Json(API.GET_ANTI_SPAM_RESULT, params)

/**
 * @description 获取商品信息
 * @param {Object} params - 必填项
 */
export const getinfolist = (params) => Json(API.GET_INFO_LIST, params)

/**
 * @description 架构组私信接口
 * @param {Object} params - 必填项
 */
export const getonlinemsg = (params) => Json(API.GET_ONLINE_MSG, params)

/**
 * @description 订单列表
 * @param {Object} params - 必填项
 */
export const getorderlist = (params) => Json(API.GET_ORDER_LIST, params)

/**
 * @description 举报详细记录
 * @param {Object} params - 必填项
 */
export const getreporthistorydetail = (params) => Json(API.GET_REPORT_HISTORY_DETAIL, params)

/**
 * @description 撤销举报
 * @param {Object} params - 必填项
 */
export const revokeReport = (params) => Json(API.REVOKE_REPORT, params)

/**
 * @description 获取撤销举报选择原因
 * @param {Object} params - 必填项
 */
export const getChooseItem = (params) => Json(API.GET_CHOOSE_ITEM, params)

/**
 * @description 获取用户举报记录
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const getreporthistorys = (params) => Json(API.GET_REPORT_HISTORYS, params)

/**
 * @description 举报内容相关数据的获取
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const getreportreasons = (params) => Json(API.GET_REPORT_REASONS, params)

/**
 * @description 举报内容相关数据的获取
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const getnoticeandshow = (params) => Json(API.GET_REPORT_NOTICEANDSHOW, params)

/**
 * @description 举报内容获取未读条数
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const getunreadcount = (params) => Json(API.GET_REPORT_UNREADCOUNT, params)

/**
 * @description 举报内容设置已读
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const sethasread = (params) => Json(API.GET_REPORT_HASREAD, params)

/**
 * @description 举报评价
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const reportaddadvise = (params) => Json(API.GET_REPORT_ADDADVISE, params)

/**
 * @description 风控获取用户图片
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const getuserpic = (params) => Json(API.FK_GET_USER_PIC, params)

/**
 * @description 暂无信息
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const hastradingorder = (params) => Json(API.HAS_TRADING_ORDER, params)

/**
 * @description 架构im登入
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const imUserLogin = (params) => Json(API.USER_LOGIN, params, 'jsonp')

/**
 * @description 架构im登出
 * @param {Object} params -必填项，以json形式传参
 * @return {Promise}
 **/
export const imUserLogout = (params) => Json(API.USER_LOGOUT, params, 'jsonp')
/**
 * @description 安全中心—首页
 * @return {Promise}
 **/
export const getSecurityCenter = (data) => Json(API.GET_SEC_CENTER, data)

/**
 * @description 安全中心—平台规则
 * @return {Promise}
 **/
export const getSecurityRule = (data) => Json(API.GET_PLAT_RULE, data)

/**
 * @description 安全中心—安全知识
 * @return {Promise}
 **/
export const getSecurityKnow = (data) => Json(API.GET_SEC_KNOW, data)

/**
 * @description 安全中心—状态详情
 * @return {Promise}
 **/
export const getSecurityCheck = (data) => Json(API.GET_SEC_CHECK, data)

/**
 * @description 安全中心—状态历史数据
 * @return {Promise}
 **/
export const getSecurityHistopry = (data) => Json(API.GET_SEC_CHECK_HISTORY, data)
/**
 * @description 安全中心—删除商品
 * @return {Promise}
 **/
export const deleteproduct = (data) => Json(API.DELETE_PRODUCT, data)

/**
 * @description 安全中心—解除限制
 * @return {Promise}
 **/
export const cancellimit = (data) => Json(API.CANCEL_LIMIT, data)

/**
 * @description 欺诈赔付—历史数据
 * @return {Promise}
 **/
export const getPayMoneyHistopry = (data) => Json(API.GET_PAY_CHECK_HISTORY, data)

/**
 * @description 欺诈赔付—申请进程详情数据
 * @return {Promise}
 **/
export const getPayMoneyDetial = (data) => Json(API.GET_PAY_CHECK_DETIAL, data)

/**
 * @description 欺诈赔付—申请赔付页校验
 * @return {Promise}
 **/
export const getPayMoneyStatus = (data) => Json(API.GET_PAY_CHECK_STATUS, data)

/**
 * @description 欺诈赔付—直接赔付订单
 * @return {Promise}
 **/
export const getPayMoneyOrderList = (data) => Json(API.GET_PAY_CHECK_APPLY_LIST, data)

/**
 * @description 欺诈赔付—需要举报订单列表
 * @return {Promise}
 **/
export const getPayMoneyReportList = (data) => Json(API.GET_PAY_CHECK_REPORT_LIST, data)

/**
 * @description 欺诈赔付—需要举报订单列表
 * @return {Promise}
 **/
export const submitPayMoney = (data) => Json(API.SUBMIT_PAY_CHECK, data, 'post')

/**
 * @description 欺诈赔付—领取列表
 * @return {Promise}
 **/
export const getPayMoneyReceive = (data) => Json(API.GET_PAY_CHECK_REPCEIVE, data)

/**
 * @description 欺诈赔付—领取保障校验
 * @return {Promise}
 **/
export const getReceiveCheck = (data) => Json(API.GET_REPCEIVE_CHECK, data)
/* @description 添加用户建议到后端服务存储
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.classify -必填项，和反馈分类标题对应
 * @param {String} params.contents -必填项，用户描述反馈的内容
 * @param {String} params.imgs -必填项，用户上传的图片名
 * @param {String} params.type -必填项，0为bug反馈，1为功能建议，2为其他
 * @param {String} params.tel -必填项，手机号
 * @param {String} params.navigator -必填项，手机机型，app版本号
 * @param {String} params.uid -必填项，用户uid
 * @return {Promise}
 **/
export const adduseradvice = (data) => Json(API.ADD_USER_ADVICE, data, 'post')

export const getuseradviceconf = (data) => Json(API.GET_USER_ADVICE_CONF, data, 'post')

/* @description 找靓机工单更改地址
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.orderId -必填项，订单id
 * @param {String} params.receiverName -必填项，收件人姓名
 * @param {String} params.receiverPhone -必填项，收件人手机号
 * @param {String} params.receiverAdress -必填项，收件人省市县
 * @param {String} params.receiverAdressDetail -必填项，收件人详细地址
 * @return {Promise}
 **/
export const zljModifyAddress = (data) => Json(API.ZLJ_MODIFY_ADDRESS, data, 'post')

// 找靓机用户静默登录
export const zljUserLogin = (params) => Json(API.ZLJ_USER_LOGIN, params, 'get')

// 检查用户是否需要跳转聊天页
export const kefuChatValid = (params) => Json(API.KEFU_CHAT_VALID, params, 'get')

/**
 * @description 资质提交-校验营业执照，法人
 * @return {Promise}
 **/
export const submitBizLicense = (data) => Json(API.SUBMIT_BIZ_LICENSE, data, 'post')

/**
 * @description 资质提交-校验经营许可证
 * @return {Promise}
 **/
export const submitBizPermit = (data) => Json(API.SUBMIT_BIZ_PERMIT, data, 'post')

/**
 * @description 资质提交-判断营业执照是否提交
 * @return {Promise}
 **/
export const getbizlicense = (data) => Json(API.GET_BIZ_LICENSE, data)

/**
 * @description 资质提交-获取许可证类型
 * @return {Promise}
 **/
export const getbizpermittype = (data) => Json(API.GET_BIZ_TYPELIST, data)

/**
 * @description 找靓机-获取实人认证提交页面文案
 * @return {Promise}
 **/
export const getsdkuserauthtext = (data) => Json(API.GET_ZLJ_REAUTH_TEXT, data)

/* @description 一键登录-用户账号绑定第三方信息
 * @param platId -必填项，第三方id，值为1
 * @param mobile -非必填项，手机号
 * @param verificationCode -非必填项，验证码
 * @param bindAction -必填项，绑定的场景，值为1
 * @param wxBindParam object 内部属性为authCode
 * @return {Promise}
 **/
export const bindThirdParty = (params) => Json(API.BIND_THIRD_PARTY, params, 'post')

/**
 * @description 语音验证
 * @return {Promise}
 **/
export const getloadingcall = (data) => Json(API.LOADINGCALL, data)

/**
 * @description 获取我的订单信息，包含欢乐送、保卖、图书订单
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.pageNo -必填项，页数
 * @param {String} params.pageSize -必填项，每页条数
 * @param {String} params.paramUid -必填项，用户uid
 * @param {String} params.orderType -必填项，订单类型：1-普通订单，2-免费送(欢乐送)  3-手机保卖  4-图书回收 5-切客 6-正品回收
 * @param {String} params.userType -必填项，用户身份：1-卖家  2-买家
 * @return {Promise}
 **/

export const getMyOrders = (params) => Json(API.GET_MY_ORDERS, params, 'get')

/**
 * @description 商品发布资质-检查审核状态
 * @param {*} data
 * @return {Promise}
 */
export const checkAuditStatus = (data) => Json(API.CHECK_AUDIT_STATUS, data)

//新资质审核-检查审核状态
export const checkAuditStatusNew = (data) => Json(API.CHECK_AUDIT_STATUS_NEW, data)
//新资质审核-提交审核信息
export const submitAuditInfoNew = (data) => Json(API.SUBMIT_AUDIT_INFO_NEW, data, 'post')

/**
 * @description 商品发布资质-提交审核信息
 * @param {*} data
 * @return {Promise}
 */
export const submitAuditInfo = (data) => Json(API.SUBMIT_AUDIT_INFO, data, 'post')

/**
 * @description 商品发布资质-获取提交页配置
 * @param {*} data
 * @return {Promise}
 */
export const getSubmitConfig = (data) => Json(API.GET_SUBMIT_CONFIG, data)
/**
 * @description 营业执照认证-获取营业执照信息
 * @return {Promise}
 **/
export const getbizlicenseinfo = (data) => Json(API.GET_BIZ_LICENSE_INFO, data)

/**
 * @description 营业执照认证-获取营业执照状态
 * @return {Promise}
 **/
export const getbizlicensestatus = (data) => Json(API.GET_BIZ_LICENSE_STATUS, data)

/**
 * @description 营业执照认证-获取营业执照认证结果页信息
 * @return {Promise}
 **/
export const getbizlicenseresult = (data) => Json(API.GET_BIZ_LICENSE_RESULT, data)

/**
 * @description 投诉中心-查询问题列表
 * @return {Promise}
 **/
export const getQuestionList = (data) => Json(API.GET_QUESTION_LIST, data)

/**
 * @description 投诉中心-提交投诉信息
 * @return {Promise}
 **/
export const addUserComplain = (data) => Json(API.ADD_USER_COMPLAIN, data)

/**
 * @description 投诉中心-获取用户投诉相关信息
 * @return {Promise}
 **/
export const checkUserComplainStatus = (data) => Json(API.CHECK_USER_COMPLAIN_STATUS, data)
/**
 * @description 客服中心-获取用户昵称
 * @return {Promise}
 **/
export const getUserInfo = (data) => Json(API.GET_USER_INFO, data)

/**
 * @description 客服中心-获取用户昵称
 * @return {Promise}
 **/
export const getCustomerCenterResult = (data) => Json(API.GET_CUSTOZMER_CENTER_RESULT, data, 'get', { timeout: 10000 })
/**
 * @description 投诉中心-获取用户投诉相关信息
 * @return {Promise}
 **/
export const getKfSelfServiceEntrance = (data) => Json(API.GET_KF_SELFSERVICE_ENTRANCE, data)

/**
 * @description 新客服中心获取需要过滤的业务线id
 * @return {Promise}
 **/
export const apiKfcenterBusinessFilter = (data) => Json(API.KF_CENTER_BUSINESS_FILTER, data)

/**
 * @description 实人认证修改姓名
 * @return {Promise}
 **/
export const apiRealAuthGetRenameInfo = (data) => Json(API.GET_RENAME_INFO, data)

/**
 * @description 实人认证修改姓名提交
 * @return {Promise}
 **/
export const apiRealAuthSubmitRenameInfo = (data) => Json(API.SUBMIT_RENAME_INFO, data, 'post')

/**
 * @description 实人认证OCR
 * @return {Promise}
 **/
export const apiNewRealAuthOCR = (data) => Json(API.NEW_REALAUTH_OCR, data)
/**
 * @description 实人认证提交机审
 * @return {Promise}
 **/
export const apiNewRealAuthSubmitAuto = (data) => Json(API.NEW_REALAUTH_SUBMIT_AUTO, data, 'post')
/**
 * @description 实人认证提交人工审核
 * @return {Promise}
 **/
export const apiNewRealAuthSubmitHandle = (data) => Json(API.NEW_REALAUTH_SUBMIT_HANDLE, data, 'post')

/**
 * @description 获取姓名身份证号
 * @return {Promise}
 **/
export const getAlreadyCertificationInfo = (data) => Json(API.GET_ALREADY_CERTIFICATION_INFO, data)

/**
 * @description 认证信息完整页面 个人信息
 * @return {Promise}
 **/
export const getPrivateInfo = (data) => Json(API.PRIVATE_INFO, data)

/**
 * @description 认证信息补充证件
 * @return {Promise}
 **/
export const privateInfoCardSupply = (data) => Json(API.PRIVATE_INFO_CARDSUPPLY, data)

/**
 * @description 新举报 获取原因
 * @return {Promise}
 **/
export const newReportGetReason = (data) => Json(API.NEW_REPORT_GET_REASON, data)

/**
 * @description 新举报 根据原因获取问题
 * @return {Promise}
 **/
export const newReportGetQuestion = (data) => Json(API.NEW_REPORT_GET_QUESTION, data)

/**
 * @description 新举报 获取样例
 * @return {Promise}
 **/
export const newReportGetExample = (data) => Json(API.NEW_REPORT_GET_EXAMPLE, data)

/**
 * @description 新举报 举报记录
 * @return {Promise}
 **/
export const newReportGetHistory = (data) => Json(API.NEW_REPORT_GET_HISTORY, data)

/**
 * @description 新举报 置为已读
 * @return {Promise}
 **/
export const newReportGetHasRead = (data) => Json(API.NEW_REPORT_GET_HAS_READ, data)

/**
 * @description 新举报 补充凭证
 * @return {Promise}
 **/
export const newReportGetRedCount = (data) => Json(API.NEW_REPORT_GET_RED_COUNT, data)

/**
 * @description 新举报 举报详情
 * @return {Promise}
 **/
export const newReportGetDetail = (data) => Json(API.NEW_REPORT_GET_DETAIL, data)

/**
 * @description 新举报 提交
 * @return {Promise}
 **/
export const newReportSubmit = (data) => Json(API.NEW_REPORT_SUBMIT, data, 'post')

/**
 * @description 新举报 补充凭证
 * @return {Promise}
 **/
export const newReportSupplySubmit = (data) => Json(API.NEW_REPORT_SUPPLY_SUBMIT, data, 'post')

/**
 * @description 新举报 评价
 * @return {Promise}
 **/
export const newReportEvaluate = (data) => Json(API.NEW_REPORT_EVALUATE, data)

/**
 * @description 个人声明信息查询
 * @return {Promise}
 **/
export const getPersonalStatement = (data) => Json(API.GET_PERSONAL_STATEMENT, data)

/**
 * @description 个人声明提交
 * @return {Promise}
 **/
export const submitPersonalStatement = (data) => Json(API.SUBMIT_PERSONAL_STATEMENT, data)

/**
 * @description 经营场所提交
 * @return {Promise}
 **/
export const submitBusinessPlace = (data) => Json(API.SUBMIT_BUSINESS_PLACE, data)

/**
 * @description 营业执照OCR
 * @return {Promise}
 **/
export const apiLicenseInfoOcr = (data) => Json(API.LICENSE_INFO_OCR, data)

/**
 * @description 营业执照更新提交
 * @return {Promise}
 **/
export const updateBizlicenseInfo = (data) => Json(API.UPDATE_BIZ_LICENSEINFO, data)

/**
 * @description 个人声明信与营业执照后端校验
 * @return {Promise}
 **/
export const getBusinessInfoByType = (data) => Json(API.GET_BUSINESS_INFO_BY_TYPE, data)

/**
 * @description 实名验证查询当前账号已认证姓名和证件类型
 * @return {Promise}
 **/
export const getLastCertificationInfo = (data) => Json(API.GET_LAST_CERTIFICATION_INFO, data)

/**
 * @description 实名验证提交接口
 * @return {Promise}
 **/
export const submitAuthenticationCheck = (data) => Json(API.SUBMIT_ATICATION_CHECK, data)

/**
 * @description 查询信息披露状态
 * @return {Promise}
 **/
export const queryDisclosureStatus = (data) => Json(API.QUERY_DISCLOSURE_STATUS, data)

/**
 * @description 查询信息披露订单相关信息
 * @return {Promise}
 **/
export const queryDisclosureOrderInfo = (data) => Json(API.QUERY_DISCLOSURE_ORDER_INFO, data)

/**
 * @description 过策略查询是否可披露
 * @return {Promise}
 **/
export const doCheckBeforeDisclosure = (data) => Json(API.DO_CHECK_BEFORE_DISCLOSUR, data)

/**
 * @description 点击获取验证码
 * @return {Promise}
 **/
export const submitDisclosureEmaile = (data) => Json(API.SUBMIT_DISCLOSUR_EMAIL, data)

/**
 * @description 邮箱验证码提交
 * @return {Promise}
 **/
export const checkDisclosureEmail = (data) => Json(API.CHECK_DISCLOSUR_EMAIL, data)

/**
 * @description 查询已经绑定邮箱
 * @return {Promise}
 **/
export const queryDisclosureEmail = (data) => Json(API.QUERY_DISCLOSURE_EMAIL, data)

/**
 * @description 提交申请
 * @return {Promise}
 **/
export const submitDisclosure = (data) => Json(API.SUBMIT_DISCLOSUR, data)

/**
 * @description 获取监督举报页配置
 * @return {Promise}
 **/
export const getCaseTrackReportConfig = (data) => Json(API.CASE_TRACK_REPORT_CONFIG, data)

/**
 * @description 监督举报提交
 * @return {Promise}
 **/
export const getSubmitCaseTrackReport = (data) => Json(API.CASE_TRACK_REPORT_SUBMIT, data)

/**
 * @description 监督举报回显
 * @return {Promise}
 **/
export const getCaseTrackStatusByOrderId = (data) => Json(API.GET_CASE_TRACK_STATUS_BY_ORDER_ID, data)

/**
 * @description 监督举报回显
 * @return {Promise}
 **/
export const supplementCaseTrackReport = (data) => Json(API.SUPPLEMENT_CASE_TRACK_REPORT, data)

/**
 * @description 安全中心-按钮跳转校验接口
 * @param {Object} params -必填项，以json形式传参
 * @param {String} params.infoId -必填项，商品ID
 * @param {String} params.ip -必填项，用户IP地址
 * @param {String} params.uid -必填项，用户ID
 * @param {String} params.token -必填项，用户token
 * @return {Promise} 返回格式：{ status: 1, message: '提示信息' }
 **/
export const safeCenterButtonCheck = (data) => Json(API.SAFE_CENTER_BUTTON_CHECK, data, 'post')

/**
 * @description 港澳台扫脸之前的提交证件照片接口
 * @param {Object} params -必填项，以json形式传参
 * @param {Long} params.uid -必填项，用户ID
 * @param {String} params.sourceCode -必填项，业务来源代码
 * @param {String} params.type -必填项，证件类型
 * @param {String} params.picKeyFro -必填项，证件正面照片key
 * @param {String} params.picKeyBack -必填项，证件背面照片key
 * @param {String} params.name -必填项，用户姓名
 * @param {String} params.cardId -必填项，证件号码
 * @return {Promise} 返回格式：{ code: 0 表示成功，code != 0 表示失败 }
 **/
export const presubmitBeforeFaceCer = (data) => Json(API.PRESUBMIT_BEFORE_FACE_CER, data, 'post')

/**
 * @description 获取实人和港澳台状态接口
 * @param {Object} params -必填项，以json形式传参
 * @param {Long} params.uid -必填项，用户ID
 * @param {Long} params.strategyId -必填项，策略ID
 * @param {String} params.sourceCode -必填项，业务来源代码
 * @return {Promise} 返回格式：{ selfCerRecStatus: '0'|'1', selfFaceStatus: '0'|'1', selfAuthStatus: '0'|'1' }
 **/
export const getCerRecognitionAndFaceStatus = (data) => Json(API.GET_CER_RECOGNITION_AND_FACE_STATUS, data, 'post')